import { render } from "./AddPermissions.vue?vue&type=template&id=72187da3&scoped=true&ts=true"
import script from "./AddPermissions.vue?vue&type=script&lang=ts"
export * from "./AddPermissions.vue?vue&type=script&lang=ts"

import "./AddPermissions.vue?vue&type=style&index=0&id=72187da3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72187da3"]])

export default __exports__